import { Asset } from "@/types";

export const mapAssetToNode = (asset: Asset) => {
  if (asset.asset_type === "dashboard") {
    return {
      ...asset,
      table: asset.asset_rk,
      type: "dashboardNode",
      nodeType: "dashboard",
      label: asset.dashboard_name,
      upstreamCount: asset.upstream_count,
      downstreamCount: asset.downstream_count,
      tables: [],
    };
  } else {
    return {
      table: asset.table || asset.asset_rk,
      upstreamCount: asset.upstream_count,
      downstreamCount: asset.downstream_count,
      label: asset.label || "",
      nodeType: asset.resource_type,
      isExternalProject: false,
      tests: (asset.tests || []).map(t => ({ key: t.name })),
      materialization: asset.materialization || null,
      schema: asset.schema_name || null,
      source: "snowflake",
    };
  }
};
